// FundManagerCommentary.js
import React , { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { abbreviateText } from './TextUtil';

//import DOMPurify from 'dompurify';
//import './FundManagerCommentary.css';

const FundManagerCommentary = ({
	backgroundColor = '',
	headline = '',
	content = '',
	brightcoveVideoPlayerUrl,
	fundManagerImage,
	commentaryHeadline = '',
	commentaryDisclaimer = '',
	fundManagerCommentaryURL
  }) => {
	const { t } = useTranslation();

	const [fundManagerCommentary, setFundManagerCommentary] = useState(null); 

	
    useEffect(() => {
		const fetchData = async () => {
		  let baseUrl = process.env.REACT_APP_DATA_URL || '#{DATA_URL}';

		  const fundResponse = await fetch(`${baseUrl}${fundManagerCommentaryURL}`);
	  
		  if (!fundResponse.ok) {
			throw new Error('HTTP error!');
		  }
	  
		  const fetchedFundCommentaryDataArray = await fundResponse.json();
		  const fundDataObject = Array.isArray(fetchedFundCommentaryDataArray) ? fetchedFundCommentaryDataArray[0] : fetchedFundCommentaryDataArray;
		  var fundManagerComments = fundDataObject?.akdComment;
		  
		  setFundManagerCommentary(fundManagerComments);

		  setTimeout(() => {
			window.applicationReInit('FundManagerCommentaryshowAll');
		  }, 100);     

		};
	  
		fetchData().catch((error) => console.error(error));
  
	}, [fundManagerCommentaryURL, fundManagerCommentary]);
  

	useEffect(() => {
		window.applicationReInit(['Brightcove']);
	}, [brightcoveVideoPlayerUrl]);

	const { returnString: fundManagerCommentaryShort, isShortened: readMore } = abbreviateText(fundManagerCommentary);

	return (
		<div className={`c-fundmanager-commentary ${backgroundColor} u-text-center`}>
			<div className="l-grid l-grid--max-width">
			
				{(headline) && (
					<div className="l-grid__row u-margin-top-none u-margin-bottom-none">
						<div className="l-grid__column-medium-12 l-grid__column-large-8 offset-large-2">
							<h2 className="c-heading  c-heading--section u-text-center">
								{headline}
							</h2>
							{(content) && (
                				<p className="c-copy center">{content}</p>
              				)}
						</div>
					</div>
				)}

			
				<div className="c-image-or-video__media">
					<div className="l-grid l-grid--max-width u-margin-bottom-20">
						<div className="c-image-or-video__image l-grid__row">
							<div className="l-grid__column-medium-8 offset-medium-2">
							{(!brightcoveVideoPlayerUrl) ? (
								<picture className="c-image">
									{fundManagerImage && (
										<img src={fundManagerImage} className="c-image__img" alt="" />
									)}
								</picture>
							) : (
								<div className="c-video ">
									<div className="c-video__iframe js-brightcove" data-embed={brightcoveVideoPlayerUrl}
										data-autoplay="false"
										data-title="" aria-label="Allianz ActiveInvest Fundmanager Commentary - Play Video" role="link" tabIndex="0">
                      					<div className="c-video__play-button" role="button"></div>
										<img src={fundManagerImage} className="c-video__thumbnail" alt="" />
									</div>
								</div>
                			)}
						</div>

					</div>

				</div>
			</div>

			<div className="l-grid__row u-margin-top-none u-margin-bottom-none js-fm-show-all">
				<div className="l-grid__column-medium-12 l-grid__column-large-8 offset-large-2 ">
					{(commentaryHeadline) && (
						<h3 className="c-heading c-heading--subsection-large">{commentaryHeadline}</h3>
					)}
					<p className="c-copy c-copy--medium js-fm-show-all-original">
						{readMore ? fundManagerCommentaryShort : fundManagerCommentary}
					</p>
					{readMore && (
						<>
							<p className="c-copy c-copy--medium u-hidden js-fm-show-all-target">
								{fundManagerCommentary}
							</p>
							<p className="c-copy c-copy--medium">
								<span className="c-link c-link--block c-teaser__link js-fm-show-all-button" aria-label="Read more">
									<span aria-hidden="true" className="c-link__icon c-icon c-icon--arrow-down"></span>
									<span className="c-link__text">{t('moreLabel')}</span>
								</span>

								<span className="c-link c-teaser__link u-hidden js-fm-show-less-button" aria-label="Read less">
									<span aria-hidden="true" className="c-link__icon c-icon c-icon--arrow-up"></span>
									<span className="c-link__text">{t('lessLabel')}</span>
								</span>
							</p>
						</>
					)}
					{commentaryDisclaimer && (
						<p className="c-copy c-copy--medium .u-margin-top-sm">
							{commentaryDisclaimer}
						</p>
					)}
	          </div>
    	    </div>
	      </div>
	    </div>
  	);
};

export default FundManagerCommentary;